import { Lock } from 'lucide-react';
import { useI18n } from '@/lib/i18n';

// UX-only locked state for entitlement-gated client areas. The backend remains
// the security authority; this simply avoids white screens / confusing errors
// when a client opens an area their package does not include.
export default function LockedFeature({ testid = 'locked-feature', reason = 'entitlement' }) {
  const { t } = useI18n();
  const isPackage = reason === 'package';
  return (
    <div className="px-6 pt-16 animate-fade-in" data-testid={testid}>
      <div className="as-card flex flex-col items-center gap-4 py-14 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-white/[0.08] bg-white/[0.03] text-asgym-muted">
          <Lock size={26} />
        </div>
        <p className="font-display text-xl font-extrabold text-white">
          {isPackage ? t('locked.noPackageTitle') : t('locked.title')}
        </p>
        <p className="max-w-[270px] text-[13px] leading-relaxed text-asgym-sub">
          {isPackage ? t('locked.noPackageSub') : t('locked.sub')}
        </p>
      </div>
    </div>
  );
}
